import { ConversationSwiperPositionState } from './_types';

export const initialState: ConversationSwiperPositionState = {
    conversationSwiperPositions: {},
};
